import { CameraTipo } from "./camera-tipo.enum";

export enum ProductType {
  "PF" = "PF",
  "PJ" = "PJ"
}

type UnicoConfig = {
  hostKey: string
  prodEnabled: boolean
}

type SerasaUnificadoLivenessConfig = {
  apiKey: string
  sdkUrl: string
  countdownToRun?: number
}

export interface EnvConfig {
  baseUrl?: string;
  baseUrlProd?: string;
  productId?: string;
  productType?: ProductType;
  autofillSocio?: boolean;
  production?: boolean;
  captchaKey?: string;
  captchaProvider?: string;
  origemComercialId?: string;
  cameraTipoIntegracao?: CameraTipo;
  fortfaceAction?: string;
  captacaoAutoEnvio?: boolean;
  nomeCampoSms?: string;
  nomeCampoTelefone?: string;
  nomeCampoDdd?: string;
  nomeCampoCpf?: string;
  nomeCampoNomeCliente?: string;
  nomeCampoCnpj?: string;
  nomeCampoRazaoSocial?: string;
  nomeCampoMetadados?: string;
  waitingLoader?: string;
  waitingMessages?: string[];
  waitingTitle?: string;
  mensagemReprovacao?: string;
  mensagemInconsistencia?: string;
  mensagemPropostaExpirada?: string;
  obrigarGeolocalizacao?: boolean;
  tamanhoMaximoAnexo?: number;
  appTitle?: string;
  urlStart?: boolean;
  btnAppRedirect?: boolean;
  urlAppRedirect?: string;
  raioLojas?: number;
  tokenIndicacao?: string;
  serasaSdkLegacyKey?: string;
  alertOnPages?: string[];
  alertOnPagesMessages?: Record<string, string>;
  consultaExternaConfig?: ConsultaExternaConfig;
  mappingCampoParaUnicoCameraType?: DocumentTypeMapping[];
  unico?: UnicoConfig | null
  buscarLojasPorProximidade?: BuscarLojasPorProximidadeConfig;
  usarFortfaceParaDocumentos?: boolean;
  verificacaoSms: boolean;
  /** Intervalo do poll de /version.json (ms). Sobrescreve o default do environment. 0 desliga o poll. */
  versionPollIntervalMs?: number;

  ['message.sent.title']?: string;
  ['message.sent.body']?: string;
  ['message.sent.footer']?: string;
  ['message.landing.title']?: string;
  ['message.biometria.body']?: string;
  ['message.confirmed.title']?: string;
  ['message.confirmed.body']?: string;
  ['menssagem.geolocalizacao.android']?: string;
  ['menssagem.geolocalizacao.ios']?: string;
  ['menssagem.geolocalizacao.desktop']?: string;
  ['mensagem.proposta.cpf.duplicado']?: string;
  ['serasa-unificado-liveness']?: SerasaUnificadoLivenessConfig | null
}
export interface DocumentTypeMapping {
  [key: string]: string;
}
export interface ConsultaExternaConfig {
  tipo?: string;
  fluxoId?: number;
  idProdutoExterno?: number;
  documentoCliente?: string;
}

export interface BuscarLojasPorProximidadeConfig {
  raioMetros: number; // raio de busca em metros
  autoSelecionarLojaMaisProxima: boolean; // se true, seleciona automaticamente a loja mais próxima
  idLojaDefault?: string | null; // ID da loja padrão caso não haja loja próxima
  desabilitarMultiplasOpcoes?: boolean;
}